// Centralized content/data for the landing site
export const NAV_LINKS = [
  { label: "Movement", href: "#movement" },
  { label: "Book", href: "#book" },
  { label: "Curriculum", href: "#curriculum" },
  { label: "Speaking", href: "#speaking" },
  { label: "Media", href: "#media" },
  { label: "Sponsor", href: "#sponsor" },
  { label: "Contact", href: "#contact" }
];

export const CHAPTER_POSTERS = [
  {
    n: 1,
    title: "The Mirror Test",
    img: "https://customer-assets.emergentagent.com/job_crash-proof-movement/artifacts/z4crkqmd_5880D145-B5AF-4A3C-BF39-4F62E6D5EBF7.png"
  },
  {
    n: 2,
    title: "The Power of Words",
    img: "https://customer-assets.emergentagent.com/job_crash-proof-movement/artifacts/vddzbbct_D35BAFF9-BBD7-446A-A7AD-098DDD808AA5.png"
  },
  {
    n: 3,
    title: "The Company You Keep",
    img: "https://customer-assets.emergentagent.com/job_crash-proof-movement/artifacts/prei3y4d_CE0F0459-EB44-457D-B074-DB561C314E56.png"
  },
  {
    n: 4,
    title: "Discipline Over Desire",
    img: "https://customer-assets.emergentagent.com/job_crash-proof-movement/artifacts/hllujrf4_D81E82A2-B7E4-40D7-B63F-84D61D075F4D.png"
  },
  {
    n: 5,
    title: "Pain as a Teacher",
    img: "https://customer-assets.emergentagent.com/job_crash-proof-movement/artifacts/64o42kfn_9D5AA3D2-C45A-4683-8DEB-87FCD2A44D65.png"
  },
  {
    n: 6,
    title: "Forgiveness & Freedom",
    img: "https://customer-assets.emergentagent.com/job_crash-proof-movement/artifacts/mmlku6uk_Chapter%206.png"
  },
  {
    n: 7,
    title: "Faith Over Fear",
    img: "https://customer-assets.emergentagent.com/job_crash-proof-movement/artifacts/u9t4i5uf_Chapter%207.png"
  },
  {
    n: 8,
    title: "Purpose Over Popularity",
    img: "https://customer-assets.emergentagent.com/job_crash-proof-movement/artifacts/ol8fcl7y_Chapter%208.png"
  },
  {
    n: 9,
    title: "Pressure Makes Purpose",
    img: "https://customer-assets.emergentagent.com/job_crash-proof-movement/artifacts/54xv5rl6_Chapter%209.png"
  },
  {
    n: 10,
    title: "The Power of Presence",
    img: "https://customer-assets.emergentagent.com/job_crash-proof-movement/artifacts/4kzzgjfl_Chapter%2010.png"
  },
  {
    n: 11,
    title: "The Power of Perspective",
    img: "https://customer-assets.emergentagent.com/job_crash-proof-movement/artifacts/qqmrllk2_Chapter%2011.png"
  },
  {
    n: 12,
    title: "The Art of Patience",
    img: "https://customer-assets.emergentagent.com/job_crash-proof-movement/artifacts/s53pd046_Chapter%2012.png"
  },
  {
    n: 13,
    title: "The Power of Peace",
    img: "https://customer-assets.emergentagent.com/job_crash-proof-movement/artifacts/2l2db5ta_Chapter%2013.png"
  },
  {
    n: 14,
    title: "Legacy Over Likes",
    img: "https://customer-assets.emergentagent.com/job_crash-proof-movement/artifacts/q3mktsca_Chapter%2014.png"
  },
  {
    n: 15,
    title: "Ca$h Out Never Crash Out",
    img: "https://customer-assets.emergentagent.com/job_crash-proof-movement/artifacts/t559w96v_Chapter%2015.png"
  }
];

export const CHAPTERS = [
  { n: "01", title: "The Mirror Test", quote: "You can't lead nobody until you can lead yourself.", note: "Self-honesty over image. Reflection before direction." },
  { n: "02", title: "The Power of Words — Say It Like You Mean It", quote: "Your mouth manifests your mindset.", note: "Speak life. Shape reality. Protect your language." },
  { n: "03", title: "The Company You Keep — Circles or Cages", quote: "Your circle is your forecast.", note: "Choose builders over bystanders." },
  { n: "04", title: "Discipline Over Desire — Move With Intention", quote: "Desire starts the fire, discipline keeps it lit.", note: "Consistency is love in motion." },
  { n: "05", title: "Pain as a Teacher — Lessons the Easy Life Won't Teach You", quote: "The wound is where wisdom walks in.", note: "Don't waste the hurt — harvest it." },
  { n: "06", title: "Forgiveness & Freedom — Letting Go So You Can Grow", quote: "Release ain't weakness, it's release from prison.", note: "Forgive, not for them — for you." },
  { n: "07", title: "Faith Over Fear — Trusting the Process When You Don't See the Promise", quote: "Walk even when you can't see the steps.", note: "Courage is faith in motion." },
  { n: "08", title: "Purpose Over Popularity — Choosing Legacy When Likes Don't Last", quote: "Clout fades. Purpose doesn't.", note: "Be timeless, not trendy." },
  { n: "09", title: "Pressure Makes Purpose — Turning Struggle into Strength", quote: "Diamonds don't form in comfort.", note: "The squeeze is sacred." },
  { n: "10", title: "The Power of Presence — Being Where Your Feet Are", quote: "Peace lives in the present.", note: "Slow down. Look around. Live here." },
  { n: "11", title: "The Power of Perspective — Seeing the Blessing in the Battle", quote: "You can't control the storm, but you can control the story.", note: "Shift the lens, see the lesson." },
  { n: "12", title: "The Art of Patience — Trusting the Wait Without Losing Your Why", quote: "Delay ain't denial — it's development.", note: "Grow while you wait." },
  { n: "13", title: "The Power of Peace — Protecting Your Energy in a World That Thrives on Chaos", quote: "Silence is strength.", note: "Guard your calm like currency." },
  { n: "14", title: "Legacy Over Likes — Building Something That Lasts Longer Than You", quote: "Likes fade. Legacy echoes.", note: "Build what can't be deleted." },
  { n: "15", title: "Ca$h Out Never Crash Out — The Code of the Comeback", quote: "The creed, the mindset, the movement.", note: "Don't fold — focus. Don't crash — Ca$h Out." }
];

export const CURRICULUM_FEATURES = [
  { icon: "brain", title: "CBT Integration", desc: "Cognitive reframing tools rooted in evidence-based therapy." },
  { icon: "compass", title: "Leadership Development", desc: "From survival mindset to ownership mentality." },
  { icon: "heart-pulse", title: "Emotional Intelligence", desc: "Name it, claim it, regulate it. Then lead with it." },
  { icon: "notebook-pen", title: "Journaling Practice", desc: "Daily reflection that turns chaos into clarity." },
  { icon: "shield", title: "Trauma-Informed Reflection", desc: "Healing without performing. Honesty without shame." },
  { icon: "handshake", title: "Conflict Resolution", desc: "Disagree without disrespecting. Stand without striking." },
  { icon: "eye", title: "Self-Awareness Training", desc: "The mirror test, weekly. Receipts on yourself." },
  { icon: "sparkles", title: "Purpose Activation", desc: "Pain into purpose, in practical steps." }
];

export const CURRICULUM_AUDIENCES = [
  "Public & Charter Schools",
  "Juvenile Justice Programs",
  "Nonprofits & CBOs",
  "Mentorship Initiatives",
  "Reentry Programs",
  "Faith Communities"
];

export const SPEAKING_TOPICS = [
  "Pain Into Purpose",
  "Leadership From The Inside Out",
  "Crash Proof: Youth Resilience",
  "Mirror Test Mentality",
  "Legacy Over Likes",
  "From Brokenness To Blueprint"
];

export const SPEAKING_VENUES = [
  "Schools & Districts",
  "Conferences & Summits",
  "Youth Empowerment Events",
  "Community Events",
  "Reentry Programs",
  "Mentorship Trainings",
  "Faith & Civic Orgs",
  "Corporate Leadership"
];

export const MERCH = [
  {
    name: "Crash Proof Hoodie",
    slogan: "Crash Proof.",
    price: "$78",
    tag: "Signature",
    img: "https://static.prod-images.emergentagent.com/jobs/003cdcec-2314-4c73-941c-5bbbdf7e39b4/images/30514df191601a253e0619dd34c70b7af4cec96cf8ecd1b7556c2de5b4698707.png"
  },
  {
    name: "Mirror Test Tee",
    slogan: "What You Avoid Controls You.",
    price: "$42",
    tag: "Premium",
    img: "https://images.unsplash.com/photo-1618354691373-d851c5c3a990?w=900&auto=format&fit=crop"
  },
  {
    name: "Legacy Cap",
    slogan: "Legacy Over Likes.",
    price: "$36",
    tag: "Heritage",
    img: "https://images.unsplash.com/photo-1521369909029-2afed882baee?w=900&auto=format&fit=crop"
  },
  {
    name: "Pain Into Purpose Journal",
    slogan: "Pain Built Perspective.",
    price: "$28",
    tag: "Daily Tool",
    img: "https://static.prod-images.emergentagent.com/jobs/003cdcec-2314-4c73-941c-5bbbdf7e39b4/images/6f6bd0597e030eeb023ad55cef1556f1ffaf57fe5fa53b37dbb140037ea6bc52.png"
  },
  {
    name: "Self Respect Long Sleeve",
    slogan: "Self Respect Is The Real Flex.",
    price: "$56",
    tag: "Limited",
    img: "https://images.unsplash.com/photo-1620799140408-edc6dcb6d633?w=900&auto=format&fit=crop"
  },
  {
    name: "Brotherhood Crewneck",
    slogan: "Friends Don't Let Friends Crash Out.",
    price: "$72",
    tag: "Drop 02",
    img: "https://images.unsplash.com/photo-1556821840-3a63f95609a7?w=900&auto=format&fit=crop"
  }
];

export const TESTIMONIALS = [
  {
    quote: "Mr. Green Bay didn't just speak at our school — he shifted the culture. Our kids are still quoting him months later.",
    name: "Dr. Marcus Hill",
    role: "High School Principal",
    role_class: "Educator"
  },
  {
    quote: "My son walked in lost. He walked out with a journal, a plan, and a different look in his eye. Damien is the real deal.",
    name: "Tonya R.",
    role: "Parent",
    role_class: "Family"
  },
  {
    quote: "The Crash Proof curriculum is the first thing we've used that actually keeps young men engaged AND honest.",
    name: "Rev. James Carter",
    role: "Mentorship Director",
    role_class: "Community"
  },
  {
    quote: "I almost crashed out. This movement gave me language for what I was feeling. Now I'm leading my own circle.",
    name: "Devon, 17",
    role: "Youth Leader",
    role_class: "Youth"
  },
  {
    quote: "Pain into purpose isn't just a phrase here — it's a framework. Our reentry program adopted it whole.",
    name: "Officer L. Daniels",
    role: "Reentry Coordinator",
    role_class: "Justice"
  },
  {
    quote: "Damien has the rare gift of holding the room AND holding individual hearts. Book him. Twice.",
    name: "Aisha Brown",
    role: "Conference Chair",
    role_class: "Organizer"
  }
];

export const MEDIA_CLIPS = [
  {
    title: "Middle School Keynote — Pt. 1",
    type: "Live · Schools",
    duration: "Clip",
    desc: "Speaking to middle schoolers on leading yourself before leading anyone else.",
    video: "/videos/keynote1.mp4",
    img: "/posters/keynote1.jpg"
  },
  {
    title: "Middle School Keynote — Pt. 2",
    type: "Live · Schools",
    duration: "Clip",
    desc: "Pain into purpose, served raw to a room of 7th graders.",
    video: "/videos/keynote2.mp4",
    img: "/posters/keynote2.jpg"
  },
  {
    title: "Middle School Keynote — Pt. 3",
    type: "Live · Schools",
    duration: "Clip",
    desc: "The Mirror Test, delivered live. No filter. No fluff.",
    video: "/videos/keynote3.mp4",
    img: "/posters/keynote3.jpg"
  },
  {
    title: "Middle School Keynote — Pt. 4",
    type: "Live · Schools",
    duration: "Clip",
    desc: "Legacy over likes — the message the room couldn't shake.",
    video: "/videos/keynote4.mp4",
    img: "/posters/keynote4.jpg"
  }
];
